/**
 * Normalize position rows (camelCase domain models or snake_case API) for widgets.
 */
export function toWidgetPosition(
  row: Record<string, unknown> | object
): Record<string, unknown> {
  const r = row as Record<string, unknown>;
  return {
    id: r.id ?? r.symbol,
    symbol: r.symbol,
    quantity: r.quantity,
    side: r.side ?? r.position_side ?? r.positionSide,
    status: r.status ?? r.state ?? r.position_status,
    average_price: r.average_price ?? r.averagePrice ?? r.avgPrice,
    current_price: r.current_price ?? r.currentPrice ?? r.mark_price ?? r.markPrice,
    market_value: r.market_value ?? r.marketValue,
    unrealized_pnl: r.unrealized_pnl ?? r.unrealizedPnl,
    mark_price: r.mark_price ?? r.markPrice ?? r.current_price ?? r.currentPrice,
  };
}

export function toWidgetPositions(
  rows: Array<Record<string, unknown> | object> | null | undefined
): Record<string, unknown>[] | null {
  if (rows == null) return null;
  return rows.map((row) => toWidgetPosition(row));
}
